import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  activeTab:String=''
  constructor() { 
    console.log(this.activeTab)
  
  }

  setActiveTab(tab){
    this.activeTab = tab;
  }

  getActiveTab():any{
    console.log(this.activeTab)
    return this.activeTab
  }
}
